import withReducer from 'app/store/withReducer';
import reducer from 'modules/ui/tablebrowser/store';
import TableBrowser from 'modules/ui/tablebrowser/TableBrowser';
import PiConnectionTableService from '../service/PiConnectionTableService';

const config = {
	key: 'piConnectionTable',
	topic: 'piConnection',
	service: PiConnectionTableService,
	editFormState: item => `/pi-connection/edit/${item ? item.id : 'new'}`,
	toolbarAction: ['search', 'refresh', 'new'],
	rowAction: ['modify', 'delete'],
	columns: [
		{ key: 'name' },
		{ key: 'apiUrl' },
		{ key: 'username' },
		{ key: 'serverId' }
	]
};

function PiConnectionTable() {
	return <TableBrowser config={config} />;
}

export default withReducer('piConnectionTable', reducer('piConnectionTable'))(PiConnectionTable);
